"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailablePremiumLookupKeys = void 0;
var lookup_key_enum_1 = require("../enums/lookup-key-enum");
var getAvailablePremiumLookupKeys = function (affiliateCode) {
    if (affiliateCode === 'kobeon') {
        return [lookup_key_enum_1.LookupKeyEnum.PremiumYearlyCzk202411];
    }
    return [
        lookup_key_enum_1.LookupKeyEnum.PremiumMonthlyCzk202605,
        lookup_key_enum_1.LookupKeyEnum.PremiumHalfYearlyCzk202605,
        lookup_key_enum_1.LookupKeyEnum.PremiumYearlyCzk202411,
    ];
};
exports.getAvailablePremiumLookupKeys = getAvailablePremiumLookupKeys;
//# sourceMappingURL=premium-offer.js.map